/*
 * Curbstruck - cbs-store-pickup
 *
 * A Curbstruck nao tem loja fisica. Este componente informa a ausencia; ele
 * NAO consulta disponibilidade e nao tem caminho de sucesso.
 *
 * Trava 1: existe uma unica funcao de renderizacao de resultado
 * (renderNoStores). Zero rede: nenhuma chamada de rede, nenhuma requisicao
 * assincrona, nenhuma leitura de disponibilidade por local, nenhum array de
 * lojas, nenhuma condicional de disponibilidade.
 *
 * Trava 4: ao renderizar o resultado, o card "Ship to me" volta a ser o
 * marcado - o estado final do formulario nunca e retirada.
 */
(function () {
  'use strict';

  var TEXT_EMPTY = 'Please enter your ZIP Code';
  var TEXT_FORMAT = 'Please enter a valid 5-digit ZIP Code';
  var TEXT_RESULT_TITLE = 'No pickup locations near ';
  var TEXT_BACK = 'Ship it to me instead';

  var ZIP_PATTERN = /^[0-9]{5}$/;

  if (customElements.get('cbs-store-pickup')) return;

  var CbsStorePickup = function () {
    return Reflect.construct(HTMLElement, [], CbsStorePickup);
  };

  CbsStorePickup.prototype = Object.create(HTMLElement.prototype);
  CbsStorePickup.prototype.constructor = CbsStorePickup;
  Object.setPrototypeOf(CbsStorePickup, HTMLElement);

  CbsStorePickup.prototype.connectedCallback = function () {
    if (this.cbsReady) return;
    this.cbsReady = true;

    this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-cbs-sp-value]'));
    this.cardShip = this.querySelector('[data-cbs-sp-value="SHIP"]');
    this.cardPick = this.querySelector('[data-cbs-sp-value="PICK"]');
    this.panel = this.querySelector('[data-cbs-sp-panel]');
    this.zip = this.querySelector('[data-cbs-sp-zip]');
    this.searchButton = this.querySelector('[data-cbs-sp-search]');
    this.errorBox = this.querySelector('[data-cbs-sp-error]');
    this.resultBox = this.querySelector('[data-cbs-sp-result]');

    if (!this.cardShip || !this.cardPick || !this.panel) return;

    // marca que o JS assumiu - o CSS so entao revela o campo de CEP
    this.setAttribute('data-cbs-sp-js', 'true');

    var self = this;

    this.cards.forEach(function (card) {
      card.addEventListener('click', function () {
        self.select(card.getAttribute('data-cbs-sp-value'));
      });
      card.addEventListener('keydown', function (event) {
        self.onCardKeydown(event, card);
      });
    });

    if (this.searchButton) {
      this.searchButton.addEventListener('click', function () {
        self.submit();
      });
    }

    if (this.zip) {
      this.zip.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          self.submit();
        }
      });
      this.zip.addEventListener('input', function () {
        self.clearError();
      });
    }

    // abrir o painel pelo <summary> equivale a escolher o card B
    this.panel.addEventListener('toggle', function () {
      if (self.panel.open && self.getAttribute('data-cbs-sp-state') === 'idle') {
        self.select('PICK');
      }
    });

    // troca de tamanho / variante devolve o modulo ao Estado 0
    this.variantListener = function (event) {
      if (!event.target || !event.target.closest) return;
      if (event.target.closest('variant-selects, variant-radios, .product-form__input')) {
        self.reset(false);
      }
    };
    document.addEventListener('change', this.variantListener, true);
  };

  CbsStorePickup.prototype.disconnectedCallback = function () {
    if (this.variantListener) {
      document.removeEventListener('change', this.variantListener, true);
    }
  };

  CbsStorePickup.prototype.onCardKeydown = function (event, card) {
    var key = event.key;

    if (key === ' ' || key === 'Enter' || key === 'Spacebar') {
      event.preventDefault();
      this.select(card.getAttribute('data-cbs-sp-value'));
      return;
    }

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      event.preventDefault();
      this.select('PICK');
      this.cardPick.focus();
      return;
    }

    if (key === 'ArrowLeft' || key === 'ArrowUp') {
      event.preventDefault();
      this.select('SHIP');
      this.cardShip.focus();
    }
  };

  CbsStorePickup.prototype.mark = function (value) {
    var checked = value === 'PICK' ? this.cardPick : this.cardShip;

    this.cards.forEach(function (card) {
      var isChecked = card === checked;
      card.setAttribute('aria-checked', isChecked ? 'true' : 'false');
      card.setAttribute('data-state', isChecked ? 'checked' : 'unchecked');
      card.setAttribute('tabindex', isChecked ? '0' : '-1');
    });
  };

  CbsStorePickup.prototype.select = function (value) {
    if (value === 'PICK') {
      this.mark('PICK');
      this.setAttribute('data-cbs-sp-state', 'form');
      this.panel.open = true;
      this.clearError();
      this.clearResult();
      if (this.zip) this.zip.focus();
      return;
    }

    this.reset(false);
  };

  CbsStorePickup.prototype.reset = function (moveFocus) {
    this.mark('SHIP');
    this.setAttribute('data-cbs-sp-state', 'idle');
    this.panel.open = false;
    this.clearError();
    this.clearResult();

    if (this.zip) {
      this.zip.value = '';
      this.zip.removeAttribute('aria-invalid');
    }

    if (moveFocus) {
      var submit = document.querySelector('product-form .product-form__submit');
      if (!submit) submit = document.querySelector('.product-form__submit');
      // botao de compra nasce desabilitado enquanto nenhum tamanho foi escolhido,
      // e elemento desabilitado nao recebe foco: cai no card "Ship to me"
      if (submit && !submit.disabled) {
        submit.focus();
      } else {
        this.cardShip.focus();
      }
    }
  };

  CbsStorePickup.prototype.clearError = function () {
    if (!this.errorBox) return;
    this.errorBox.textContent = '';
    this.errorBox.hidden = true;
    if (this.zip) this.zip.removeAttribute('aria-invalid');
  };

  CbsStorePickup.prototype.clearResult = function () {
    if (this.resultBox) this.resultBox.textContent = '';
  };

  CbsStorePickup.prototype.showError = function (state, message) {
    this.clearResult();
    this.setAttribute('data-cbs-sp-state', state);

    if (this.errorBox) {
      this.errorBox.textContent = '';
      var alert = document.createElement('p');
      alert.setAttribute('role', 'alert');
      alert.textContent = message;
      this.errorBox.appendChild(alert);
      this.errorBox.hidden = false;
    }

    if (this.zip) {
      this.zip.setAttribute('aria-invalid', 'true');
      this.zip.focus();
    }
  };

  CbsStorePickup.prototype.submit = function () {
    var value = this.zip ? this.zip.value.trim() : '';

    if (value === '') {
      this.showError('error-empty', TEXT_EMPTY);
      return;
    }

    if (!ZIP_PATTERN.test(value)) {
      this.showError('error-format', TEXT_FORMAT);
      return;
    }

    this.renderNoStores(value);
  };

  /*
   * Unica funcao de renderizacao de resultado do componente.
   * Nao existe variante de sucesso: qualquer CEP valido cai aqui.
   */
  CbsStorePickup.prototype.renderNoStores = function (zipValue) {
    this.clearError();

    // Trava 4 - o card marcado volta a ser "Ship to me"
    this.mark('SHIP');
    this.setAttribute('data-cbs-sp-state', 'no-stores');

    if (!this.resultBox) return;

    this.resultBox.textContent = '';

    var title = document.createElement('p');
    title.className = 'cbs-sp__result-title';
    title.textContent = TEXT_RESULT_TITLE + zipValue;

    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'cbs-sp__back';
    back.textContent = TEXT_BACK;

    var self = this;
    back.addEventListener('click', function () {
      self.reset(true);
    });

    this.resultBox.appendChild(title);
        this.resultBox.appendChild(back);
  };

  customElements.define('cbs-store-pickup', CbsStorePickup);
})();
